import { AavoFormActionButtons } from "src/components/common/forms/AavoFormActionButtons.tsx";
import { useCatalogPartRevisionConfiguratorManagingViewContext } from "src/components/views/erp/configurator/managing/catalogPart/configuratorSelections/catalogPartRevisionConfiguratorSelectionsViewContext.ts";

export const CatalogPartRevisionConfiguratorSelectionsViewFooter = () => {
	const { submitAndClose, cancelAndClose, limitedEditing } = useCatalogPartRevisionConfiguratorManagingViewContext();

	return <AavoFormActionButtons onSubmit={limitedEditing ? undefined : submitAndClose} onCancel={cancelAndClose} />;
};
